import { Column } from '@miq/catalog';
import { DataObject } from '@shared/models/data-object.model';
export enum OpportunitiesActionTypes {
  Create = 'create',
  Delink = 'delink',
}
export interface OpportunityRecord {
  attributes: {
    type: string;
    url: string;
  };
  Id: string;
  Name: string;
  Primary_Contact__c: string;
  Primary_Contact__r: PrimaryContactRecord;
  Type: string;
  Service__c: string;
  Service_Sub_Type__c: string;
  Asset_Type__c: string;
  Opportunity_Owner__c: string;
  EMEA_Asset_Class__c: string;
  Owner: OwnerRecord;
  Total_Size__c?: number;
  Unit_of_Measure__c?: string;
}
export interface PrimaryContactRecord {
  attributes: {
    type: string;
    url: string;
  };
  EDP_ID__c: string;
}
export interface OwnerRecord {
  attributes: {
    type: string;
    url: string;
  };
  Email: string;
}
export interface OpportunitiesModel {
  opportunities: Opportunity[];
  isAccessCIQ: boolean;
  message: string;
}
export interface Opportunity {
  attributes: {
    type: string;
    url: string;
  };
  Id: string;
  Name: string;
  Opportunity_No__c: string;
  Service__c: string;
  Phase__c: string;
  CloseDate: string;
  Confidential_Opportunity__c: boolean;
  Opportunity_Owner__c: string;
}
export interface OpportunityDetails {
  totalSize: number;
  done: boolean;
  records: OpportunityRecord[];
}
export interface OpportunitiesData {
  columns: Column[];
  record?: DataObject;
  entityId?: number;
  leaseToLink?: number;
  entity: string;
  isCloseEnquiryFlow?: boolean;
}
export type OpportunityColumn = Pick<Column, 'header' | 'field'> & {
  navigate?: boolean;
  expand?: boolean;
  sortable?: boolean;
};
export interface OpportunityExpandInfo {
  [opportunityId: string]: {
    expanded: boolean;
    isExpandable: boolean;
  };
}
export interface ColumnOppExpandInfo {
  [columnField: string]: OpportunityExpandInfo;
}
export const LEASE_OPPORTUNITIES_COLUMNS: OpportunityColumn[] = [
  {
    header: 'records.lease.opportunities.opportunityId',
    field: 'Opportunity_No__c',
    navigate: true,
    sortable: true,
  },
  {
    header: 'records.lease.opportunities.opportunityName',
    field: 'Name',
    expand: true,
    sortable: true,
  },
  {
    header: 'records.lease.opportunities.opportunityOwner',
    field: 'Opportunity_Owner__c',
    expand: true,
    sortable: true,
  },
  {
    header: 'records.lease.opportunities.opportunityAssignment',
    field: 'Service__c',
    sortable: true,
  },
  {
    header: 'records.lease.opportunities.opportunityPhase',
    field: 'Phase__c',
    sortable: true,
  },
  {
    header: 'records.lease.opportunities.opportunityCloseDate',
    field: 'CloseDate',
    sortable: true,
  },
];
